"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_TYPES = void 0;
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["keyUp"] = "keyUp";
    ACTION_TYPES["keyDown"] = "keyDown";
    ACTION_TYPES["keyTap"] = "keyTap";
    ACTION_TYPES["open"] = "open";
    ACTION_TYPES["url"] = "url";
    ACTION_TYPES["play"] = "play";
    ACTION_TYPES["typeString"] = "typeString";
    ACTION_TYPES["run"] = "run";
    ACTION_TYPES["getPrefs"] = "getPrefs";
    ACTION_TYPES["setPrefs"] = "setPrefs";
    ACTION_TYPES["setClientLocation"] = "setClientLocation";
    ACTION_TYPES["setFeatureFlags"] = "setFeatureFlags";
    ACTION_TYPES["image"] = "image";
    ACTION_TYPES["gameSpecificAction"] = "gameSpecificAction";
    ACTION_TYPES["screenshot"] = "screenshot";
    ACTION_TYPES["batchActions"] = "batchActions";
    ACTION_TYPES["delay"] = "delay";
    ACTION_TYPES["showParent"] = "showParent";
    ACTION_TYPES["keyPress"] = "keyPress";
    ACTION_TYPES["click"] = "click";
    ACTION_TYPES["exec"] = "exec";
    ACTION_TYPES["mWheel"] = "mWheel";
    ACTION_TYPES["mouseWheel"] = "mouseWheel";
})(ACTION_TYPES = exports.ACTION_TYPES || (exports.ACTION_TYPES = {}));
//# sourceMappingURL=actionTypes.js.map